/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetChapterNumbers } from '../../../../../api/masters/masters';
import { useGetPsLegalRegionList } from '../../../../../api/pss/pss';
import { useDefaultOptions } from '../../../../../hooks/api';
import '../../../../../styles/Dropdown.css';
import { PsDiffBModal } from './PsDiffBModal';
import { PsDiffLModal } from './PsDiffLModal';
import { PsDiffPModal } from './PsDiffPModal';

interface Props {
  sectionId: number;
  isReadOnlySection: boolean;
}

/* 原稿編集画面 PS差異用のプルダウン */
function PsDiffCommand({ sectionId, isReadOnlySection }: Props) {
  const {
    i18n: { language },
    t,
  } = useTranslation();
  const options = useDefaultOptions(language);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownListRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const handleClickToCloseDropdown = (event: any) => {
      const element = dropdownListRef.current;
      if (!showDropdown || element?.contains(event.target)) return;
      setShowDropdown(false);
    };
    window.addEventListener('click', handleClickToCloseDropdown);
    return () => {
      window.removeEventListener('click', handleClickToCloseDropdown);
    };
  }, [showDropdown, dropdownListRef]);

  const [displayModalP, setDisplayModalP] = useState(false); // PS差異
  const [displayModalL, setDisplayModalL] = useState(false); // 法規適用国
  const [displayModalB, setDisplayModalB] = useState(false); // Ｂ項目確認

  // 章番号取得
  const chapterNumbersRes = useGetChapterNumbers(options);
  const chapterNumbers = useMemo(
    () => chapterNumbersRes.data?.data.chapter_numbers ?? [],
    [chapterNumbersRes.data?.data.chapter_numbers]
  );

  // 法規適用国リスト取得。
  const getPsLegalRegionListResponse = useGetPsLegalRegionList(options);
  const legalRegionData = useMemo(
    () => getPsLegalRegionListResponse.data?.data ?? [],
    [getPsLegalRegionListResponse.data?.data]
  );

  return (
    <div className="dropdowncontainer">
      <span
        className="dropdownopen"
        onClick={() => !isReadOnlySection && setShowDropdown((prevState) => !prevState)}
        ref={dropdownListRef}
        style={{
          width: '120px',
          color: isReadOnlySection ? '#9d9d9d' : '',
          cursor: isReadOnlySection ? 'default' : 'pointer',
        }}
      >
        <i
          className="fa-solid fa-code-compare"
          style={{
            color: isReadOnlySection ? '#9d9d9d' : '',
            cursor: isReadOnlySection ? 'default' : 'pointer',
          }}
        />
        {t('PS差異')}
      </span>
      {showDropdown && (
        <ul className="dropdownlist" style={{ width: '120px' }}>
          <li className="dropdownitem" onClick={() => setDisplayModalP(true)}>
            {t('PS差異')}
          </li>
          <li className="dropdownitem" onClick={() => setDisplayModalL(true)}>
            {t('法規確認')}
          </li>
          <li className="dropdownitem" onClick={() => setDisplayModalB(true)}>
            {t('Ｂ項目確認')}
          </li>
        </ul>
      )}
      {/* PS差異モーダル */}
      <PsDiffPModal open={displayModalP} onClose={() => setDisplayModalP(false)} sectionId={sectionId} />
      {/* 法規適用国モーダル */}
      {displayModalL && (
        <PsDiffLModal
          open={displayModalL}
          onClose={() => setDisplayModalL(false)}
          sectionId={sectionId}
          legalRegionData={legalRegionData}
        />
      )}
      {/* Ｂ項目確認モーダル */}
      {displayModalB && (
        <PsDiffBModal
          open={displayModalB}
          onClose={() => setDisplayModalB(false)}
          sectionId={sectionId}
          chapterNumbers={chapterNumbers}
        />
      )}
    </div>
  );
}
export default PsDiffCommand;
